import api from "../../../service/api";

const buildUrl = (practicePk) =>
    `clearing-house/practice/${practicePk}/auto-ev-settings/`;

export const getAutoEVSettings = (practicePk) => {
    return api.get(buildUrl(practicePk));
};

export const updateAutoEVSettings = (practicePk, data) => {
    return api.put(buildUrl(practicePk), data);
};
